import React from "react";
import '../ServicesInfo/servicesInfo.css'


function LinkedinOutReach(){
    return(
        <div id="linkedin">
            <div className="row w-100 m-0">

                <div className="col-lg-6 background_lightGrey">
                    <div className="servicesBox_padding">
                        <h1 className="main_heading">01</h1>
                        <div className="bar rounded"></div>
                        <h2 className='main_heading titleFont_style py-2'>LinkedIn Outreach</h2>
                        <p className="text">
                            We use LinkedIn as a precision B2B channel to engage senior decision-makers and professionals in a natural, non-intrusive way.
                        </p>
                        <span className='span_Titles text-dark ' ><b>Core Niches</b></span>

                        <div className="caseList d-flex flex-wrap py-2">
                            <ul className="all_type_list p-0 pe-5">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Ideal client profile (ICP) and decision-maker research </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Personalized connection requests and follow-ups</li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Conversation-based engagement (no aggressive pitching) </li>
                            </ul>
                            
                            <ul className="all_type_list p-0 ">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Lead qualification and meeting booking </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> CRM logging and pipeline hygiene </li>
                            </ul>
                        </div>

                        <div>
                            <span className='span_Titles text-dark ' ><b>Best for:</b></span>
                            <p className="text">B2B companies, professional services, corporate partnerships, and executive-level outreach.</p>
                        </div>

                        <a href="/contact" target='_blank' className="btn blue_btn rounded">DISCUSS YOUR PROJECT <i class="fa-solid fa-arrow-right ms-2"></i> </a>
                    </div>
                </div>

                <div className="col-lg-6 p-0 bg-dark">
                    <div className="Col_bg linkedin-outreach"></div>
                </div>
                
            </div>
        </div>
    )
}

export default LinkedinOutReach;